// import Numeral from 'numeral';
import moment from 'moment';
import Vue from 'vue';
import numeral from 'numeral'

Number.prototype.leftZeroPad = function(numZeros) {
	var n = Math.abs(this);
	var zeros = Math.max(0, numZeros - Math.floor(n).toString().length);
	var zeroString = Math.pow(10, zeros).toString().substr(1);
	if (this < 0) {
		zeroString = '-' + zeroString;
	}

	return zeroString + n;
}

Number.prototype.moneyFormat = function(lang) {
	if (lang == "en") {
		return numeral(this).format('$0,0[.]00');
	} else {
		return numeral(this).format('0,0[.]00 $');
	}
}


Number.prototype.isNumber = function() {
	return !isNaN(parseFloat(this)) && isFinite(this);
}


String.prototype.formatUnicorn = function() {
	"use strict";
	var str = this.toString();
	if (arguments.length) {
		var t = typeof arguments[0];
		var key;
		var args = ("string" === t || "number" === t) ?
			Array.prototype.slice.call(arguments) :
			arguments[0];

		for (key in args) {
			str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
		}
	}

	return str;
}



String.prototype.isNumber = function() {
	return !isNaN(parseFloat(this)) && isFinite(this);
}

String.prototype.toTitleCase = function() {
	var i, j, str, lowers, uppers;
	str = this.replace(/([^\W_]+[^\s-]*) */g, function(txt) {
		txt = txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();

		// Deal with names that start with Mc
		if (txt.charAt(0) == "M" && txt.charAt(1) == "c") {
			txt = txt.charAt(0) + txt.charAt(1) + txt.charAt(2).toUpperCase() + txt.substr(3);
		}

		return txt;
	});

	// Certain minor words should be left lowercase unless
	// they are the first or last words in the string
	lowers = ['A', 'An', 'The', 'And', 'But', 'Or', 'For', 'Nor', 'As', 'At',
  'By', 'For', 'From', 'In', 'Into', 'Near', 'Of', 'On', 'Onto', 'To', 'With', 'Du'];
	for (i = 0, j = lowers.length; i < j; i++)
		str = str.replace(new RegExp('\\s' + lowers[i] + '\\s', 'g'),
			function(txt) {
				return txt.toLowerCase();
			});

	// Certain words such as initialisms or acronyms should be left uppercase
	uppers = ['Id', 'Tv', 'Ii', 'Iii', 'Iv', 'V', 'Ix'];
	for (i = 0, j = uppers.length; i < j; i++)
		str = str.replace(new RegExp('\\b' + uppers[i] + '\\b', 'g'),
			uppers[i].toUpperCase());

	// 'Macgregor'
	str = str.replace(new RegExp('Macgregor', 'g'), 'MacGregor');

	return str;
}

export default class Format {

	static createDataTree = dataset => {
		let hashTable = Object.create(null)
		dataset.forEach(aData => hashTable[aData.id] = {...aData,
			children: []
		})
		let dataTree = []
		dataset.forEach(aData => {
			if (aData.parentId) hashTable[aData.parentId].children.push(hashTable[aData.id])
			else dataTree.push(hashTable[aData.id])
		})
		return dataTree
	}


	static TryParseInt(str) {
		var retValue = null;
		if (str && !isNaN(str) && /^\d+$/g.test(str)) {
			retValue = parseInt(str);
		}
		return retValue;
	}

	static address(value) {
		if (value) {
			return value.toTitleCase();
		} else {
			return value;
		}
	}
	static name(value) {
		if (value) {
			return value.toTitleCase();
		}
		return value;
	}


	/**
	 * Function to sort alphabetically an array of objects by some specific key.
	 *
	 * @param {String} property Key of the object to sort.
	 */
	static dynamicSort(property) {
		var sortOrder = 1;

		if (property[0] === "-") {
			sortOrder = -1;
			property = property.substr(1);
		}

		return function(a, b) {
			if (sortOrder == -1) {
				return b[property].localeCompare(a[property]);
			} else {
				return a[property].localeCompare(b[property]);
			}
		}
	}



	static fixStreetSuffix(value) {
		// TODO: Fix all of the street suffixes...
		if (value != null) {
			value = value.replace(new RegExp(" Av$", "gm"), " Avenue");
			value = value.replace(new RegExp(" St$", "gm"), " Street");
			value = value.replace(new RegExp(" Rd$", "gm"), " Road");
		}
		return value;

	}

	static fileSize(bytes, decimalPoint) {
		if (bytes == 0) return '0 Bytes';
		var k = 1000,
			dm = decimalPoint || 2,
			sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}
	static pipesToFlatTree(str) {
		if (str) {
			let pipes = str.split("|");
			let newStr = "";
			let x = 0;
			let count = 0;
			let firstX = -1;
			let start = "";
			let end = "";
			start = "<span class='flat-tree first'>";
			end = "</span>";
			for (x = 0; x < pipes.length; x++) {
				if (pipes[x] != "") {
					if (firstX < 0) {
						firstX = x;
					}
					newStr += start + pipes[x] + end;
					start = "<span class='flat-tree'>";
					end = "</span>";
					count++;
				}
			}
			if (count == 1) {
				// only one item change first to only-one
				newStr = "<span class='flat-tree only-one'>";
				newStr += pipes[firstX];
				newStr += "</span>";
			}
			return newStr;
		}
		return null;
	}


	static pipesToArrows(str) {
		let pipes = str.split("|");
		let newStr = "";
		let x = 0;
		let arrow = "";
		for (x = 0; x < pipes.length; x++) {
			if (pipes[x] != "") {
				newStr += arrow + pipes[x];
				arrow = " > ";
			}
		}
		return newStr;
	}

	static postalCode(value) {
		if (value) {
			var parts = value.match(/^([A-Za-z][0-9][A-Za-z])\s*([0-9][A-Za-z][0-9])$/);
			if (parts) {
				parts.shift();
				value = parts.join(' ').toUpperCase();
			}
			return value.toUpperCase();
		} else {
			return value;
		}
	}

	static city(value) {
		if (value) {
			return value.toTitleCase();
		}
		return value;
	}

	static phone(value) {
		var parts = null;
		if (value) {
			value = value.replace(new RegExp('[^0-9]', 'g'), "");

			if (value.length == 11) {
				parts = value.match(/^([0-9])([0-9][0-9][0-9])([0-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/);
				if (parts) {
					value = "+" + parts[1] + "(" + parts[2] + ") " + parts[3] + "-" + parts[4];
				}
			}

			if (value.length == 10) {
				parts = value.match(/^([0-9][0-9][0-9])([0-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/);
				if (parts) {
					value = "(" + parts[1] + ") " + parts[2] + "-" + parts[3];
				}
			}
			if (value.length == 7) {
				parts = value.match(/^([0-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/);
				if (parts) {
					value = parts[1] + "-" + parts[2];
				}
			}
			return value;
		} else {
			return value;
		}
	}

	static makeId(value) {
		value = value.replace(new RegExp('[^0-9a-zA-Z]', 'g'), "");
		return value;
	}

	static hrefPhone(value) {
		if (value) {
			value = value.replace(new RegExp('[^0-9]', 'g'), "");
			if (value) {
				return "tel:" + value;
			}
		}
		return null;
	}

	static hrefEmail(value) {
		if (value) {
			value = value.toLowerCase();
			if (value) {
				return "mailto:" + value;
			}
		}
		return null;
	}



	static email(value) {
		if (value) {
			return value.toLowerCase();
		} else {
			return value;
		}
	}

	static searchByGroupedId(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].options) {
				for (let ii = 0; ii < iArray[i].options.length; ii++) {
					if (iArray[i].options[ii].id === nameKey) {
						return iArray[i].options[ii]
					}
				}
			}
		}
	}

	static searchById(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].id === nameKey) {
				return iArray[i]
			}
		}
	}

	static searchByKeyInArray(searchValue, key, array) {
		for (let i = 0; i < array.length; i++) {
			if (eval(`array[i].${key}`) === searchValue) {
				return array[i]
			}
		}
	}
	static capitalize(str = '') {
		return str.toLowerCase().split(' ').map(function(word) {
			return (word.charAt(0).toUpperCase() + word.slice(1));
		}).join(' ');
	}
	static capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	static padLeft(str = '', pad, chr = '') {
		if (typeof str != 'string') {
			str = str.toString()
		}
		pad = chr.repeat(pad)
		return pad.substring(0, pad.length - str.length) + str
	}

	static diffYMDHMS(date1Value, date2Value) {
		let date1 = moment(date1Value);
		let date2 = moment(date2Value);

		let years = Math.abs(date1.diff(date2, 'year'));
		date2.add(years, 'years');

		let months = Math.abs(date1.diff(date2, 'months'));
		date2.add(months, 'months');

		let days = Math.abs(date1.diff(date2, 'days'));
		date2.add(days, 'days');

		let hours = Math.abs(date1.diff(date2, 'hours'));
		date2.add(hours, 'hours');

		let minutes = Math.abs(date1.diff(date2, 'minutes'));
		date2.add(minutes, 'minutes');

		let seconds = Math.abs(date1.diff(date2, 'seconds'));

		return {
			years,
			months,
			days,
			hours,
			minutes,
			seconds
		};
	}

	static addWeekdays(date, days) {
		if (date == null) {
			date = moment(); // use a clone
		} else {
			date = moment(date); // use a clone
		}
		while (days > 0) {
			date = date.add(1, 'days');
			// decrease "days" only if it's a weekday.
			if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
				days -= 1;
			}
		}
		return date;
	}


	static subtractWeekdays(date, days) {
		if (date == null) {
			date = moment(); // use a clone
		} else {
			date = moment(date); // use a clone
		}
		while (days > 0) {
			date = date.subtract(1, 'days');
			// decrease "days" only if it's a weekday.
			if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
				days -= 1;
			}
		}
		return date;
	}



	static getApiUrl(url) {
		return Vue.prototype.$store.state.apiUrl + url + "?r=" + Math.round(Math.random() * Math.pow(10, 6));
	}


	static diffYMDHMSAgo(date1Value, date2Value) {
		let date1 = moment(date1Value);
		let date2 = moment(date2Value);

		let years = date1.diff(date2, 'year');
		date2.add(years, 'years');

		let months = date1.diff(date2, 'months');
		date2.add(months, 'months');

		let days = date1.diff(date2, 'days');
		date2.add(days, 'days');

		let hours = date1.diff(date2, 'hours');
		date2.add(hours, 'hours');

		let minutes = date1.diff(date2, 'minutes');
		date2.add(minutes, 'minutes');

		let seconds = date1.diff(date2, 'seconds');

		return {
			years,
			months,
			days,
			hours,
			minutes,
			seconds
		};
	}


	getFlatTree(option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
	}


	static decodePolyline(encoded) {
		if (!encoded) {
			return [];
		}
		var poly = [];
		var index = 0,
			len = encoded.length;
		var lat = 0,
			lng = 0;

		while (index < len) {
			var b, shift = 0,
				result = 0;

			do {
				b = encoded.charCodeAt(index++) - 63;
				result = result | ((b & 0x1f) << shift);
				shift += 5;
			} while (b >= 0x20);

			var dlat = (result & 1) != 0 ? ~(result >> 1) : (result >> 1);
			lat += dlat;

			shift = 0;
			result = 0;

			do {
				b = encoded.charCodeAt(index++) - 63;
				result = result | ((b & 0x1f) << shift);
				shift += 5;
			} while (b >= 0x20);

			var dlng = (result & 1) != 0 ? ~(result >> 1) : (result >> 1);
			lng += dlng;

			var p = {
				lat: lat / 1e5,
				lng: lng / 1e5,
			};
			poly.push(p);
		}
		return poly;
	}

}